import requestService from "./requestService"

export default {
    async updatePassword(customer_id, password) {
        return await requestService.post('/customer-configurations/update-password', {
            customer_id: customer_id,
            password: password
        })
    }
}